import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JobActivityService {
  receivedDownloadTimelineReportRequest: EventEmitter<any>;

  constructor() {
    this.receivedDownloadTimelineReportRequest = new EventEmitter<any>();
  }

  raiseEventForTimelineReportDownload(link: string, jobId: string): void {
    this.receivedDownloadTimelineReportRequest.emit({ link, jobId });
  }

  // invalidate() {
  //   this.timeLineMsgSubject$.next(null);
  // }
}
